import './App.css';

function CallLineItem({ call, searchText }) {
  const highlightText = (text) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, 'gi');
    return text.replace(regex, '<mark style="background-color: yellow">$1</mark>');
  };

  return (
    <div className="max-w-4xl mx-auto">
      <article className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 my-6 p-6">
        <header className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              <a 
                href={call.external ? call.external_url : call.path}
                className="hover:text-blue-600 transition-colors duration-200 flex items-center gap-2"
              >
                <img 
                  className="w-4 h-4"
                  src={`https://www.google.com/s2/favicons?domain=${new URL(call.external_url).hostname}`}
                  alt={new URL(call.external_url).hostname}
                />
                <span dangerouslySetInnerHTML={{ __html: highlightText(call.name) }} />
              </a>
            </h2>
            <p className="text-sm text-gray-500">
              Deadline: <time>{call.entry_deadline}</time>
            </p>
          </div>
        </header>

        {call.description && (
          <div className="prose prose-sm max-w-none text-gray-600 mb-4">
            <div dangerouslySetInnerHTML={{ 
              __html: highlightText(call.expanded_description)
            }} />
          </div>
        )}

        {window.location.hostname === 'localhost' && (
          <div className="mb-4">
            <a 
              href={`http://localhost:3001/api/v1/development/scrape_call/${call.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 hover:text-blue-800"
            >
              Scrape Call
            </a>
          </div>
        )}

        <footer className="flex items-center justify-between pt-4 border-t border-gray-100">
          {call.entry_fee !== null && (
            <div className="text-sm font-medium text-gray-700">
              {call.entry_fee === 0 ? (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                  🎉 FREE Entry!
                </span>
              ) : (
                `Entry fee: $${Math.round(call.entry_fee / 100)}`
              )}
            </div>
          )}
          
          <a 
            href={call.external ? call.external_url : call.path}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
          >
            Apply Now
          </a>
        </footer>
      </article>
    </div>
  );
}

export default CallLineItem;
